import { getServerTime } from "@/api/php/serverConfig";

const OFFSET_KEY = "UpdateTime.offsetSeconds";
const LAST_SYNC_KEY = "UpdateTime.lastSyncLocalTime";

class UpdateTime {
    /* ========= 静态单例 ========= */
    private static _instance: UpdateTime | null = null;

    static shared(): UpdateTime {
        if (!UpdateTime._instance) {
            UpdateTime._instance = new UpdateTime();
        }
        return UpdateTime._instance;
    }

    /* ========= 实例属性 ========= */
    private offsetSeconds: number;
    private lastSyncLocalTime: number | null;
    private timer: ReturnType<typeof setInterval> | null;

    private constructor() {
        // 读缓存（防止冷启动没校准）
        this.offsetSeconds = Number(localStorage.getItem(OFFSET_KEY)) || 0;
        this.lastSyncLocalTime =
            Number(localStorage.getItem(LAST_SYNC_KEY)) || null;

        this.timer = null;
    }

    /* ========= 启动：立即校准 + 每小时自动校准 ========= */
    startAutoSync(): void {
        this.syncNow();

        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }

        this.timer = setInterval(() => {
            this.syncNow();
        }, 60 * 60 * 1000); // 1小时
    }

    /* ========= 手动校准 ========= */
    async syncNow(): Promise<void> {
        const localNow = Date.now();

        try {
            const res = await getServerTime();
            const serverNow = UpdateTime.parseServerTime(res);
            if (!serverNow) return;

            this.offsetSeconds = (serverNow - localNow) / 1000;
            this.lastSyncLocalTime = Date.now();

            localStorage.setItem(OFFSET_KEY, String(this.offsetSeconds));
            localStorage.setItem(
                LAST_SYNC_KEY,
                String(this.lastSyncLocalTime)
            );
        } catch (e) {
            // 网络失败：沿用旧 offset
        }
    }

    /* ========= 获取校准后的当前时间 ========= */
    calibratedNow(): Date {
        return new Date(Date.now() + this.offsetSeconds * 1000);
    }

    static calibratedNow(): Date {
        return UpdateTime.shared().calibratedNow();
    }

    /* ========= 解析服务器时间 ========= */
    static parseServerTime(res: any): number | null {
        if (!res || typeof res !== "object") return null;

        const data = res.data;
        if (!data) return null;

        const unix = data.unix_time;
        if (typeof unix === "number") {
            return unix * 1000;
        }
        if (typeof unix === "string" && unix.length > 0) {
            return Number(unix) * 1000;
        }

        return null;
    }
}

export default UpdateTime;
